import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from 'layouts/Admin.js';
import { userSelector } from 'slices/userSlice';
import { useSelector } from 'react-redux';
import Api from './services/api';
import DashboardAdmin from 'views/Dashboard';

export const ProtectedRoutes = () => {
    const { isAuthenticated, user } = useSelector(userSelector);
    Api.setClientToken(user?.token);
    return (
        <>
            <Routes>
                {/* Agar user authenticated nahi hai, toh unhe login page pe redirect kar do */}
                {!isAuthenticated && (
                    <Route path="*" element={<Navigate to="/login" replace />} />
                )}


                {/* Authenticated Users */}
                {isAuthenticated && (
                    <>
                        <Route path="/*" element={<AdminLayout />} />
                        <Route path="/*dashboard" element={<DashboardAdmin />} />
                        <Route path="/*" element={<Navigate to="/dashboard" replace />} />
                    </>

                )}

                {/* Default redirects */}
                <Route path="/login" element={<Navigate to={!isAuthenticated ? "/login" : "/"} replace />} />
                {/* 404 Page */}
                {/* <Route path="*" element={<Navigate to="/404" replace />} /> */}
            </Routes>
        </>
    );
};
